function getNavigationJSON(type: string, url: string, data: any, title: string, id?: any, host?: boolean) {
    try {
        let jsonNavSession = require('./json-interfaces/navigation.session.json');
        let jsonNavEscalated = require('./json-interfaces/navigation.cookieEscalated.json');
        let jsonNavReactNativeReact = require('./json-interfaces/navigation.reactNativeReact.json');
        let jsonNavReactNative = require('./json-interfaces/navigation.reactNative.json');
        let jsonNavReactNativeGCO = require('./json-interfaces/navigation.reactNativeGCO.json');
        let jsonNavReactNativeProfile = require('./json-interfaces/navigation.reactNative-profile.json');
        let jsonNavProfile = require('./json-interfaces/navigation.profile.json');
        let jsonNavRequestAppVersion = require('./json-interfaces/navigation.requestAppVersion.json');
        let jsonNavReactNativeLogoutPassword = require('./json-interfaces/navigation.reactNative-logoutPassword.json');
        let jsonResults = {};

        delete jsonNavReactNativeReact.data.topBar.rightButtons;
        switch (type) {
            //MODO FLOW
            case 'modeFlow-backgroundBlue': {
                if (Object.keys(data).length === 0) {
                    delete jsonNavReactNativeReact.data.request.parameters;
                } else {
                    jsonNavReactNativeReact.data.request.parameters = data;
                }
                jsonNavReactNativeReact.data.request.endpointUrl = host ? `${window.location.origin}${url}` : url;
                jsonNavReactNativeReact.data.mode = 'FLOW';
                jsonNavReactNativeReact.data.topBar.title = title;
                jsonNavReactNativeReact.data.topBar.backgroundColor = '#00008C';
                jsonNavReactNativeReact.data.topBar.tintColor = '#FFFFFF';
                jsonResults = jsonNavReactNativeReact;
                break;
            }
            //MODO MODAL
            case 'modeModal-backgroundBlue': {
                if (Object.keys(data).length === 0) {
                    delete jsonNavReactNativeReact.data.request.parameters;
                } else {
                    jsonNavReactNativeReact.data.request.parameters = data;
                }
                jsonNavReactNativeReact.data.request.endpointUrl = host ? `${window.location.origin}${url}` : url;
                jsonNavReactNativeReact.data.topBar.title = title;
                jsonNavReactNativeReact.data.mode = 'MODAL';
                jsonNavReactNativeReact.data.topBar.backgroundColor = '#00008C';
                jsonNavReactNativeReact.data.topBar.tintColor = '#FFFFFF';
                jsonResults = jsonNavReactNativeReact;
                break;
            }
            //MODO FEEDBACK
            case 'feedback-success': {
                jsonNavReactNative.data.data.type = data.state;
                jsonNavReactNative.data.data.title = data.title;
                jsonNavReactNative.data.data.subtitle = data.subtitle;
                jsonResults = jsonNavReactNative;
                break;
            }
            case 'feedback-info': {
                jsonNavReactNative.data.data.type = data.state;
                jsonNavReactNative.data.data.title = data.title;
                jsonNavReactNative.data.data.subtitle = data.subtitle;
                jsonNavReactNative.data.data['codeProblem'] = data.codeProblem;
                jsonResults = jsonNavReactNative;
                break;
            }
            case 'feedback-error': {
                jsonNavReactNative.data.data.type = data.state;
                jsonNavReactNative.data.data.title = data.title;
                jsonNavReactNative.data.data.subtitle = data.subtitle;
                jsonNavReactNative.data.data['errorReference'] = data.errorCode;
                jsonResults = jsonNavReactNative;
                break;
            }
            // MODO MODAL WITH WHITE BACKGROUND
            case 'modeModal-backgroundWhite': {
                if (Object.keys(data).length === 0) {
                    delete jsonNavReactNativeReact.data.request.parameters;
                } else {
                    jsonNavReactNativeReact.data.request.parameters = data;
                }
                jsonNavReactNativeReact.data.request.endpointUrl = host ? `${window.location.origin}${url}` : url;
                jsonNavReactNativeReact.data.topBar.title = title;
                jsonNavReactNativeReact.data.mode = 'MODAL';
                jsonNavReactNativeReact.data.topBar.backgroundColor = '#FFFFFF';
                jsonNavReactNativeReact.data.topBar.tintColor = '#00001E';
                jsonResults = jsonNavReactNativeReact;
                break;
            }
            //MODO FLOW WITH WHITE BACKGROUND
            case 'modeFlow-backgroundWhite': {
                if (Object.keys(data).length === 0) {
                    delete jsonNavReactNativeReact.data.request.parameters;
                } else {
                    jsonNavReactNativeReact.data.request.parameters = data;
                }
                jsonNavReactNativeReact.data.request.endpointUrl = host ? `${window.location.origin}${url}` : url;
                jsonNavReactNativeReact.data.topBar.title = title;
                jsonNavReactNativeReact.data.topBar.backgroundColor = '#FFFFFF';
                jsonNavReactNativeReact.data.topBar.tintColor = '#00001E';
                jsonNavReactNativeReact.data.mode = 'FLOW';
                jsonResults = jsonNavReactNativeReact;
                break;
            }
            //FLOW WITH BUTTONS
            case 'fiber-test-speed': {
                if (Object.keys(data).length === 0) {
                    delete jsonNavReactNativeReact.data.request.parameters;
                } else {
                    jsonNavReactNativeReact.data.request.parameters = data;
                }
                jsonNavReactNativeReact.data.request.endpointUrl = host ? `${window.location.origin}${url}` : url;
                jsonNavReactNativeReact.data.mode = 'FLOW';
                jsonNavReactNativeReact.data.topBar.title = title;
                let rightButtons = [{ id: 'INFO_SPEED_TEST', imageName: 'information-user-regular' }];
                jsonNavReactNativeReact.data.topBar['rightButtons'] = rightButtons;
                jsonResults = jsonNavReactNativeReact;
                break;
            }
            //CALLDIVERT
            case 'callDivert': {
                if (Object.keys(data).length === 0) {
                    delete jsonNavReactNativeReact.data.request.parameters;
                } else {
                    jsonNavReactNativeReact.data.request.parameters = data;
                }
                jsonNavReactNativeReact.data.request.endpointUrl = host ? `${window.location.origin}${url}` : url;
                jsonNavReactNativeReact.data.mode = 'FLOW';
                jsonNavReactNativeReact.data.topBar.title = title;
                let rightButtons = [{ id: 'CALLDIVERT', imageName: 'information-user-regular' }];
                jsonNavReactNativeReact.data.topBar['rightButtons'] = rightButtons;
                jsonResults = jsonNavReactNativeReact;
                break;
            }
            //ORDERS
            case 'ordersInfo': {
                if (Object.keys(data).length === 0) {
                    delete jsonNavReactNativeReact.data.request.parameters;
                } else {
                    jsonNavReactNativeReact.data.request.parameters = data;
                }
                jsonNavReactNativeReact.data.request.endpointUrl = host ? `${window.location.origin}${url}` : url;
                jsonNavReactNativeReact.data.mode = 'MODAL';
                jsonNavReactNativeReact.data.topBar.title = title;
                let rightButtons = [{ id: 'ORDERS', imageName: 'question-regular' }];
                jsonNavReactNativeReact.data.topBar['rightButtons'] = rightButtons;
                jsonResults = jsonNavReactNativeReact;
                break;
            }
            //MODE EXTERNAL
            case 'modeExternal': {
                delete jsonNavReactNativeReact.data.request.parameters;
                jsonNavReactNativeReact.data.request.endpointUrl = url;
                jsonNavReactNativeReact.data.mode = 'EXTERNAL';
                jsonNavReactNativeReact.data.topBar.title = '';
                jsonResults = jsonNavReactNativeReact;
                break;
            }
            case 'download-bill-android': {
                delete jsonNavReactNativeReact.data.request.parameters;
                jsonNavReactNativeReact.data.request.base64 = data.base64;
                jsonNavReactNativeReact.data.mode = 'DOWNLOAD_BILL';
                jsonNavReactNativeReact.data.topBar.title = title;
                jsonResults = jsonNavReactNativeReact;
                break;
            }
            case 'download-bill': {
                delete jsonNavReactNative.data.data.type;
                delete jsonNavReactNative.data.data.title;
                delete jsonNavReactNative.data.data.subtitle;
                const event = {
                    type: 'NAVIGATION_NATIVE',
                    data: {
                        id: 'PDF',
                        mode: 'MODAL',
                        topBar: {
                            title,
                            type: 'SHORT',
                            backgroundColor: '#00008C',
                            tintColor: '#FFFFFF',
                        },
                        data: {
                            base64: data.base64,
                        },
                    },
                };
                jsonResults = event;
                break;
            }
            //MODE BROWSER
            case 'modeBrowser': {
                delete jsonNavReactNativeReact.data.request.parameters;
                jsonNavReactNativeReact.data.request.endpointUrl = url;
                jsonNavReactNativeReact.data.mode = 'BROWSER';
                jsonNavReactNativeReact.data.topBar.title = title;
                jsonNavReactNativeReact.data.topBar.backgroundColor = '#FFFFFF';
                jsonNavReactNativeReact.data.topBar.tintColor = '#00001E';
                jsonResults = jsonNavReactNativeReact;
                break;
            }
            case 'modeBrowser-backgroundBlue': {
                delete jsonNavReactNativeReact.data.request.parameters;
                jsonNavReactNativeReact.data.request.endpointUrl = url;
                jsonNavReactNativeReact.data.mode = 'BROWSER';
                jsonNavReactNativeReact.data.topBar.title = title;
                jsonNavReactNativeReact.data.topBar.tintColor = '#FFFFFF';
                jsonNavReactNativeReact.data.topBar.backgroundColor = '#00008C';
                jsonResults = jsonNavReactNativeReact;
                break;
            }
            //MODE GCO
            case 'gco-navigation': {
                jsonNavReactNativeGCO.data.data.endpointUrl = data.webviewUrl;
                jsonNavReactNativeGCO.data.data.callBackUrl = data.callBackUrl;
                jsonResults = jsonNavReactNativeGCO;
                break;
            }
            //NAVIGATION GLOBAL PROFILE
            case 'navigation-global-profile': {
                if (Object.keys(data).length === 0) {
                    delete jsonNavProfile.data.request.parameters;
                } else {
                    jsonNavProfile.data.request.parameters = data;
                }
                jsonNavProfile.data.request.endpointUrl = `${window.location.origin}/profile`;
                jsonResults = jsonNavProfile;
                break;
            }
            //MODE NAVIGATION NATIVE PROFILE
            case 'navigation-native-profile': {
                jsonNavReactNativeProfile.data.id = id;
                jsonNavReactNativeProfile.data.mode = 'FLOW';
                jsonNavReactNativeProfile.data.topBar.title = title;
                jsonResults = jsonNavReactNativeProfile;
                break;
            }
            case 'navigation-native-critical-error': {
                jsonNavReactNative.data.id = 'CRITICAL_ERROR';
                jsonNavReactNative.data.mode = 'FULL_SCREEN';
                jsonNavReactNative.data.data.id = `${data.id}`;
                jsonNavReactNative.data.data.title = data.title;
                jsonNavReactNative.data.data.localizedDescription = data.localizedDescription;
                jsonNavReactNative.data.data.httpCode = data.httpCode;
                delete jsonNavReactNative.data.data.type;
                delete jsonNavReactNative.data.data.title;
                delete jsonNavReactNative.data.data.subtitle;
                jsonResults = jsonNavReactNative;
                window.localStorage.clear();
                window.sessionStorage.clear();
                break;
            }
            case 'navigation-native-logout': {
                jsonNavReactNative.data.id = 'LOGOUT_ALERT';
                jsonNavReactNative.data.mode = 'FULL_SCREEN';
                delete jsonNavReactNative.data.data;
                jsonResults = jsonNavReactNative;
                window.localStorage.clear();
                window.sessionStorage.clear();
                break;
            }
            case 'navigation-camera-permission': {
                jsonNavReactNative.data.id = 'PERMISSIONS_REQUEST';
                jsonNavReactNative.data.mode = 'FULL_SCREEN';
                jsonNavReactNative.data.data.id = 'CAMERA';
                delete jsonNavReactNative.data.data.type;
                delete jsonNavReactNative.data.data.title;
                delete jsonNavReactNative.data.data.subtitle;
                jsonResults = jsonNavReactNative;
                break;
            }
            case 'navigation-light-titular': {
                jsonNavReactNative.data.id = 'USER_UPGRADE_ALERT';
                jsonNavReactNative.data.mode = 'FULL_SCREEN';
                delete jsonNavReactNative.data.data;
                jsonResults = jsonNavReactNative;
                window.localStorage.clear();
                window.sessionStorage.clear();
                break;
            }
            case 'navigation-refresh-cookie': {
                jsonNavSession.data.data = data.data;
                jsonResults = jsonNavSession;
                break;
            }
            case 'navigation-synchronized-cookie': {
                jsonNavEscalated.data.data = data.data;
                jsonResults = jsonNavEscalated;
                break;
            }
            case 'navigation-request-app-version': {
                jsonResults = jsonNavRequestAppVersion;
                break;
            }
            case 'navigation-native-change-password': {
                jsonNavReactNativeLogoutPassword.data.data.title = data.title;
                jsonNavReactNativeLogoutPassword.data.data.subtitle = data.subtitle;
                jsonResults = jsonNavReactNativeLogoutPassword;
                window.localStorage.clear();
                window.sessionStorage.clear();
                break;
            }
            default: {
                break;
            }
        }
        return JSON.stringify(jsonResults);
    } catch (error) {
        console.error(error);
    }
}

export default getNavigationJSON;
